import { BaseViewModel } from "./base.viewmodel";

export class ServiceDetailsViewModel implements BaseViewModel {
    PageTitle: string = 'Service Details';
}